import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class CoinToss extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.CoinToss &&
            gameContext.getOvertimePeriod() === 1
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { settings } = fragment;
        gameContext.setPossessionForTeamId(settings.offenseTeam.id);
        gameContext.setDriveContext({
            triggerDrive: true
            // previousDriveEndType: DriveEndType.EndOfGame
        });
        ruleContext.setResetField(true);
        gameContext.setCoinTossRequired(false);
    }
}
